import React from 'react';

export const PageTitle = ({ title }) => <h2 className="title-page">{title}</h2>;



// WEBPACK FOOTER //
// ./foody/src/components/Common/PageTitle.jsx